var _style, _rect, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobYellowHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 600",
    style: {
      enableBackground: "new 0 0 900 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFF6DC;}\n\t.st2{fill:#FFE696;}\n\t.st3{fill:#FFD64A;}\n\t.st4{fill:#FFCE00;}\n\t.st5{display:none;}\n\t.st6{display:inline;fill:#FFF6DC;}\n\t.st7{display:inline;fill:#FFE696;}\n\t.st8{display:inline;fill:#FFD64A;}\n\t.st9{display:inline;fill:#FFCE00;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 900,
    height: 600
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-486.8,600c6.8-63.3,13.6-126.6,37-186.3c23.4-59.7,63.4-115.7,113.8-149.6c50.5-33.8,111.3-45.5,169.1-66.9 c57.7-21.5,112.2-52.7,166.8-83.9V600H-486.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-365.1,600c5.2-47.5,10.3-94.9,27.8-139.7c17.6-44.8,47.6-86.8,85.4-112.2s83.5-34.1,126.8-50.2 s84.2-39.5,125.1-63V600H-365.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-243.4,600c3.4-31.6,6.8-63.3,18.6-93.1c11.7-29.9,31.6-57.9,56.9-74.8c25.2-17,55.6-22.8,84.5-33.5 c28.8-10.7,56.1-26.4,83.4-42V600H-243.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-121.7,600c1.7-15.8,3.4-31.6,9.3-46.6c5.8-14.9,15.8-28.9,28.4-37.4c12.6-8.4,27.9-11.3,42.3-16.7 c14.4-5.4,28.1-13.2,41.7-21V600H-121.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 600)",
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0-486.7c47.5,44.7,95,89.4,157.7,106.1c62.6,16.7,140.4,5.4,186.5,36.4c46.1,31.1,60.5,104.5,78.9,168.9 C441.6-110.8,464.2-55.4,486.7,0H0V-486.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M0-365.1c35.6,33.6,71.3,67.1,118.2,79.6c47,12.5,105.4,4.1,139.9,27.4c34.6,23.3,45.4,78.3,59.3,126.6 C331.2-83.1,348.1-41.6,365.1,0H0V-365.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0-243.4c23.8,22.4,47.5,44.7,78.8,53.1c31.4,8.3,70.2,2.7,93.3,18.2c23,15.5,30.2,52.3,39.5,84.5 c9.2,32.2,20.5,59.9,31.8,87.6H0V-243.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M0-121.7c11.9,11.2,23.8,22.4,39.4,26.5C55.1-91,74.5-93.8,86-86c11.6,7.7,15.2,26.1,19.8,42.2 C110.4-27.7,116-13.9,121.7,0H0V-121.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobYellowHalf);
export default __webpack_public_path__ + "static/media/blob_yellow_half.4f84ee2907900acf0cb6f28b612c6402.svg";
export { ForwardRef as ReactComponent };